import {StrictMode} from 'react';
import {render} from '@wordpress/element';

/**
 * Import the stylesheet for the plugin.
 */
import {OurClients} from "./components/OurClients";

// Render the App component into the DOM
render(
    <StrictMode>
        <OurClients/>
    </StrictMode>
    , document.getElementById('our-clients-page-root')
);